import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToContact = () => {
    document.getElementById('contact-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-107">
      <div className="absolute inset-0 w-full h-full z-0" data-id="element-108">
        <div className="absolute inset-0 bg-cream/80 md:bg-cream/40 z-10" data-id="element-109"></div>
        <img src="https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?q=80&w=2000&auto=format&fit=crop" alt="Luxury spa interior" className="w-full h-full object-cover object-right" data-id="element-110" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-20 w-full" data-id="element-111">
        <div className="max-w-3xl" data-id="element-112">
          <div className="inline-block border border-charcoal/20 px-4 py-1.5 mb-8 text-xs font-semibold tracking-[0.2em] uppercase bg-cream/50 backdrop-blur-sm" data-id="element-113">
            Turnkey Support for Investors & Founders
          </div>

          <h1 className="text-5xl md:text-7xl font-serif leading-[1.1] mb-6 text-balance" data-id="element-114">
            Buy a Profitable Beauty Business in Dubai With Confidence.
          </h1>

          <p className="text-lg md:text-xl text-charcoal-light mb-10 max-w-2xl leading-relaxed font-light" data-id="element-115">
            Avoid costly mistakes before investing. We help you evaluate,
            structure and launch beauty salons, aesthetic clinics and wellness
            businesses in Dubai with a clear financial and operational roadmap.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-116">
            <button onClick={scrollToContact} className="group bg-charcoal text-white px-8 py-4 flex items-center justify-center gap-3 text-sm font-medium tracking-wide hover:bg-gold transition-all duration-300" data-id="element-117">
              Book a Strategy Call
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-118" />
            </button>
            <a href="#services" className="px-8 py-4 flex items-center justify-center text-sm font-medium tracking-wide border border-charcoal hover:bg-charcoal hover:text-white transition-all duration-300 bg-cream/50 backdrop-blur-sm" data-id="element-119">
              Explore Our Services
            </a>
          </div>
        </div>
      </div>
    </section>;
}